/**
 * 059 R6: verification status in customer wording.
 *
 * Not `StatusBadge` — its shared map calls `pending` a warning, and on this screen `pending`
 * means "you have not submitted anything yet", which is not a problem with the customer.
 */

export type IdentityStatus = 'pending' | 'submitted' | 'approved' | 'rejected' | 'resubmitted';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

export interface StatusView {
  label: string;
  variant: BadgeVariant;
}

const VIEWS: Record<IdentityStatus, StatusView> = {
  pending: { label: 'Not submitted', variant: 'default' },
  submitted: { label: 'In review', variant: 'info' },
  approved: { label: 'Approved', variant: 'success' },
  rejected: { label: 'Rejected', variant: 'danger' },
  // 199 (#288): a customer replaced a document on an already-approved record. The customer does
  // not need to know it was previously approved — from their side this reads exactly like any
  // other review-in-progress state, same copy as a first-time submission. Staff are the ones who
  // need to tell the two apart (admin's UserListPage badge does that).
  resubmitted: { label: 'In review', variant: 'info' },
};

export function statusView(status: IdentityStatus): StatusView {
  return VIEWS[status];
}
